import { SubmoduleScopeType } from '@api/company';
import { CLIENT_USER_ROLE } from './client-user-management';

export enum PVX_PARTNERS_TYPE {
  FINANCE = 'FINANCE',
  LP = 'LP',
  REFERRER = 'REFERRER',
  INVESTOR = 'INVESTOR',
  OTHER = 'OTHER',
}

export interface AdminPvxPartnersListingRequest {
  pageNumber: number;
  pageSize: number;
  search: string;
  sort: string;
  sortOrder: 'ASC' | 'DESC';
  role?: CLIENT_USER_ROLE[];
  status?: string[];
  partnerType?: PVX_PARTNERS_TYPE[];
}

export interface AdminPvxPartnersDashboardSubmodule {
  submoduleId: string;
  submoduleName: string;
  submoduleType: string;
  accessType?: string;
  scopeType?: SubmoduleScopeType;
}

export interface AdminPvxPartnersUserDashboards {
  hasFullAccess: boolean;
  assignedCount: number;
  totalEntitlementCount: number;
  submodules: AdminPvxPartnersDashboardSubmodule[];
}

export interface AdminPvxPartnersListingUser {
  membershipGrantId: string;
  userId: string;
  email: string;
  companyRole: CLIENT_USER_ROLE;
  status: string;
  joiningDate: string | null;
  dashboardAccess: AdminPvxPartnersUserDashboards;
}

export interface AdminPvxPartnersListingItem {
  clientCode: string;
  companyName: string;
  totalEntitlementCount: number;
  userCount: number;
  partnerType: PVX_PARTNERS_TYPE;
  users: AdminPvxPartnersListingUser[];
}

export interface PvxPartnersListingResponse {
  totalPages: number;
  totalElements: number;
  items: AdminPvxPartnersListingItem[];
}

export interface PvxPartnerDetailsPayload {
  name: string;
  address?: string;
  partnerType: PVX_PARTNERS_TYPE;
  entityType: string;
  pvxPocEmail?: string;
  email: string;
  username: string;
}

export interface AdminCreatePvxPartnerResponse {
  clientCode: string;
}

export interface PvxPartnerDashboardGame {
  gameId: string;
  iconUrl: string | null;
  name: string;
}

export interface PvxPartnerDashboardCompany {
  clientCode: string;
  companyName: string;
}

export interface PvxPartnerDashboardSubmodule {
  editable: boolean;
  submoduleId: string;
  submoduleName: string;
  submoduleType: string;
}

export interface PvxPartnerDashboardsResponse {
  games: PvxPartnerDashboardGame[];
  companies: PvxPartnerDashboardCompany[];
  submodules: PvxPartnerDashboardSubmodule[];
}

export interface PvxPartnerUpdateDashboardsRequest {
  clientCode: string;
  submoduleIds: string[];
}

export interface FilterEntitlementEntry {
  filterName: 'game_id' | 'client_code';
  filterValues: string[];
}

export interface PvxPartnerFilterEntitlementsRequest {
  clientCode: string;
  filters: FilterEntitlementEntry;
}

export interface PvxPartnerProfileApiResponse {
  id: string;
  name: string;
  clientCode: string;
  address?: string | null;
  companyHQ?: string | null;
  companyType: string;
  partnerType: PVX_PARTNERS_TYPE;
  entityType: string;
  pvxPocEmail?: string | null;
  ownerEmail: string | null;
  ownerUsername: string | null;
}

export interface PvxPartnerProfileResponse extends PvxPartnerDetailsPayload {
  id: string;
  clientCode: string;
}

export interface EditPvxPartnerProfileRequest {
  clientCode: string;
  name: string;
  address?: string;
  partnerType: PVX_PARTNERS_TYPE;
  entityType: string;
  pvxPocEmail?: string;
}

export interface FilterEntitlementValue {
  value: string;
  label: string | null;
}

export interface FilterEntitlement {
  filterName: string;
  values: FilterEntitlementValue[];
}

export interface BasicCompanyDetails {
  clientCode: string;
  name: string;
  companyType: string;
}
